import { render, staticRenderFns } from "./minimizable-modal.vue?vue&type=template&id=5a520d9c&"
import script from "./minimizable-modal.vue?vue&type=script&lang=js&"
export * from "./minimizable-modal.vue?vue&type=script&lang=js&"
import style0 from "./minimizable-modal.vue?vue&type=style&index=0&id=5a520d9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports